import request from '@/utils/request'

/**
 * 获取拼团退单列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listProductGroupOrderReturn(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listProductGroupOrderReturn',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}